import {Component, isValidElement} from 'rlink-react';
import {merge} from 'rlink-utils/object';

exports.createActions = function (actions) {
  let actionCtx = {
    dispatcher: global.AppDispatcher,
  };
  let actionCollection = {};
  for (let name in actions) {
    actionCollection[name] = (function (innerName) {
      return (function (payload) {
        let actionFn = actions[innerName];
        let newPayload = actionFn.call(actions[innerName], payload);
        let dispatch = {
          payload: newPayload,
          name: innerName,
          action: actionCollection[name],
          dispatcher: actionCtx.dispatcher,
        };
        actionCtx.dispatcher.dispatch(dispatch);
        return dispatch;
      });
    })(name);
  }
  for (let name in actionCollection) {
    actionCollection[name].displayName = `action.${name}`;
  }
  return actionCollection;
};

exports.suggestStateFor = function (subKey, payload) {
  let newPayload = Object.assign({}, payload);
  newPayload.suggestState = {};
  newPayload.suggestState[subKey] = payload.suggestState;
  return newPayload;
};

exports.suggestActionsForState = function (subKey) {
  return function (action) {
    return function handler (payload) {
      action(exports.suggestStateFor(subKey, payload));
    };
  };
};



/**
 * Read store state from store in property of given name
 * @param {string|Object} store The name of the property that contains
 *   the store (defaults to `"store"`), or the store object itself
 *   directly.
 * @return {Object} a store.
 */
exports.StoreStateMixin = function (store) {
  return {
    getStore () {
      if (store === undefined) {
        store = 'store';
      }
      if (typeof store === 'string') {
        // it's a property name!
        return this.props[store];
      } else {
        return store;
      }

    },

    getInitialState () {
      return this.getStateFromStore();
    },

    getStateFromStore () {
      return this.getStore().getFullState();
    },

    componentDidMount () {
      this.getStore().registerComponent(this);
    },

    componentWillUnmount () {
      this.getStore().unregisterComponent(this);
    },

    storeStateDidChange (originatingStore, callback) {
      this.setState(this.getStateFromStore(), callback);
    },
  };
};


/**
 * Like the above, but an ES6 style subclass
 *
 * UPDATE: this has began to diverge form the above implementation.
 * However since the above is only really used for "legacy"
 * components, this is fine - they won't be using (or expect) the
 * new behavior.
 */
export class FluxStoreBoundComponent extends Component {
  constructor (props) {
    super(props);
    this.state = this.getStateFromStore();
  }

  getStore () {
    // note! can also return an array of stores, whose state is
    // merged
    return this.props.store;
  }

  getStateFromStore () {
    let stores = this.getStore();

    if (!Array.isArray(stores)) {
      stores = [stores];
    }

    return merge(...stores.map(store => store.getFullState()));
  }

  componentDidMount () {
    let stores = this.getStore();

    if (!Array.isArray(stores)) {
      stores = [stores];
    }

    stores.map(store => store.registerComponent(this));
  }

  componentWillUnmount () {
    let stores = this.getStore();

    if (!Array.isArray(stores)) {
      stores = [stores];
    }

    stores.map(store => store.unregisterComponent(this));
  }

  storeStateDidChange (originatingStore, callback) {
    this.setState(this.getStateFromStore(), callback);
  }
}

exports.Dispatcher = function Dispatcher () {
  this.registeredStores = [];
};

exports.Dispatcher.prototype = {
  dispatch (dispatch) {
    // console.info("Dispatch:", dispatch.action.displayName, dispatch.payload);
    for (let i = 0; i < this.registeredStores.length; i++) {
      let store = this.registeredStores[i];
      store.onDispatch(dispatch);
    }
  },

  registerStore (store) {
    this.registeredStores.push(store);
  },
};

global.AppDispatcher = new exports.Dispatcher();

global.$stores = global.$stores || {};

export class Store {
  constructor (dispatcher) {
    this.registeredComponents = [];
    if (typeof dispatcher === 'undefined') {
      dispatcher = global.AppDispatcher;
    }
    dispatcher.registerStore(this);

    if (this.constructor.name in global.$stores) {
      if (!Array.isArray(global.$stores[this.constructor.name])) {
        global.$stores[this.constructor.name] = [global.$stores[this.constructor.name]];
      }
      global.$stores[this.constructor.name].push(this);
    } else {
      global.$stores[this.constructor.name] = this;
    }


  }

  registerComponent (component) {
    console.info('Registering component ', component, ' with ', this);
    this.registeredComponents.push(component);
  }

  unregisterComponent (component) {
    console.info('Un-registering component ', component, ' with ', this);

    let toDelete = null;

    for (let i = 0; i < this.registeredComponents.length; i++) {
      let thisComponent = this.registeredComponents[i];

      if (component === thisComponent) {
        toDelete = i;
        break;
      }
    }

    if (toDelete !== null) {
      this.registeredComponents.splice(toDelete, 1);
    }
  }

  notifyChanged (callback) {
    for (let i = 0; i < this.registeredComponents.length; i++) {
      let component = this.registeredComponents[i];

      if (component.storeStateDidChange) {
        component.storeStateDidChange(this, callback);
      }
    }
  }

}

function mergeState (oldState, newState) {
  let didChange = false;

  for (let key in newState) {
    let value = newState[key];

    if (typeof value === 'object'
        && value !== null
        && !Array.isArray(value)
        && !isValidElement(value)
        && global.Node && !(value instanceof global.Node)) {
      if ( mergeState(oldState[key], value) ) {
        didChange = true;
      }
    } else {
      if (oldState[key] !== value) {
        oldState[key] = value;
        didChange = true;
      }
    }
  }

  return didChange;
}

export class PageStateStore extends Store {
  mergeState (newState) {
    return mergeState(this.state, newState);
  }

  changeState (newState, callback) {
    if ( mergeState(this.state, newState) ) {
      this.notifyChanged(callback);
      return true;
    }
  }

  replaceState (newState, callback) {
    this.state = newState;
    this.notifyChanged(callback);
  }

  getFullState () {
    return this.state;
  }
}



// WEBPACK FOOTER //
// ./lib/rlink-flux/index.js